import {
    GET_FORMS, GET_FORMS_BY_IDS, DELETE_FORMS, UPDATE_CURRENT_FORM, CLEAR_FORM, SET_CURRENT_FORM_TITLE
} from '../constants/action-types';

const newForm = () => ({
    "Name": null,
    "Pages": [],
    "IsActive": true,
    "ModuleType": "form",
    "Description": null,
    "FrequencyConfiguration": null,
    "CreatedAt": new Date(),
    "ModifiedAt": new Date(),
    "Version": 1,
    "FormType": [],
    "ReferenceData": {},
    "Questions": {},
    "FormGroups": {},
    "Requirements": {},
    "Outcomes": {},
    "Visibilities": {},
    "Validations": {},
    "Calculations": {}
})

// INITIALIZE STATE
const initialState = {
    forms: {},
    currentForm: {}
};


// REDUCER
export const FormsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_FORMS: {
            const incomingForms = action.payload;
            const forms = {};

            incomingForms.forEach((form) => {
                forms[form.id] = form;
            });

            return {
                ...state,
                forms
            }
        }
        case DELETE_FORMS: {
            const formIdsToDelete = action.payload;
            const forms = Object.assign({}, state.forms);

            formIdsToDelete.forEach((formId) => {
                delete forms[formId];
            });

            return {
                ...state,
                forms
            }
        }
        case GET_FORMS_BY_IDS: {
            const incomingForms = action.payload;
            const forms = Object.assign({}, state.forms);

            incomingForms.forEach((form) => {
                forms[form.id] = form;
            });

            return {
                ...state,
                forms
            }
        }

        case UPDATE_CURRENT_FORM: {
            const currentForm = action.payload

            return {
                ...state,
                currentForm
            }
        }

        case CLEAR_FORM: {
            const form = newForm()

            return {
                ...state,
                currentForm: form
            }
        }

        case SET_CURRENT_FORM_TITLE: {
            var form = Object.assign({}, state.currentForm)
            const title = action.payload

            if (form.Pages == null) {
                form = newForm()
            }

            form.Name = title

            return {
                ...state,
                currentForm: form
            }
        }

        default:
            return state;
    }
};